import { FC } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Home from 'views/screens/Platform-administrator/Home'
import NotFound from 'views/screens/NotFound'
import IdealProfileBetesa from 'views/screens/Platform-administrator/Process/Create/IdealProfileBetesa'
import PlatformSkills from 'views/screens/Platform-administrator/Skills'
import Test360 from 'views/screens/Platform-administrator/Process/Create/Test360'
import Analytics from 'views/screens/Platform-administrator/Analytics'
import AnalyticsMigrationNotice from 'views/screens/Platform-administrator/AnalyticsMigrationNotice'
import LuminaAnalytics from 'views/screens/Platform-administrator/LuminaAnalytics/lumina-analytics'
import Inventory from 'views/screens/inventory/inventory'
import MyProcesses from 'views/screens/Platform-administrator/Process/MyProcess'
import DeliveredProcesses from 'views/screens/Platform-administrator/Process/DetailProcessDelivered/detail-process-delivered'
import UsersWithIncompletedTests from 'views/screens/Platform-administrator/Process/Create/Users/UsersIncompletedTests'
import EvaluatorsTest360 from 'views/screens/Platform-administrator/Process/Create/Users/EvaluatorsTest360/evaluators-test360'
import UnpublishProcess from 'views/screens/Platform-administrator/Process/DraftProcesses'
import DeliveredProcess from 'views/screens/Platform-administrator/Process/Delivered/delivered-processes'
import EvaluatedSpace from 'views/screens/Platform-administrator/EvaluatedSpace'
import EvaluatedDetail from 'views/screens/Platform-administrator/EvaluatedDetail'
import ProfileView from 'views/screens/Platform-administrator/Profile'
import CreateUsers from 'views/screens/Platform-administrator/Process/Create/Users'
import CreateUsersNewProcess from 'views/screens/Platform-administrator/Process/Create/Users/Create'
import ResumeUsersProcess from 'views/screens/Platform-administrator/Process/Resume/users-resume-to-send-test'
import UpdateEmail from 'views/screens/Platform-administrator/Process/UpdateEmail'
import CreateProcess from 'views/screens/Platform-administrator/Process/Create'
import SelectPreconfig from 'views/screens/Platform-administrator/Process/Create/SelectPreconfigProcess'
import SelectTestsType from 'views/screens/Platform-administrator/Process/Create/SelectTestsType'
import IdealProfileGeneratorAi from 'views/screens/Platform-administrator/Process/Create/IdealProfileGeneratorAi/ideal-profile-generator-ai'
import HomologationSkills from 'views/screens/Platform-administrator/Process/Create/HomologationSkills'
import HomologationCreateEditSkills from 'views/screens/Platform-administrator/Process/Create/HomologationSkills/HomologationCreateEditSkills'
import ProcessSkills from 'views/screens/Platform-administrator/Process/Create/Skills'
import TalentsToDevelop from 'views/screens/Platform-administrator/TalentsToDevelop'
import SelectTalentsToDevelop from 'views/screens/Platform-administrator/SelectTalentsToDevelop'
import SelectSkillsToDevelop from 'views/screens/Platform-administrator/DevelopmentPlan/SelectSkillsToDevelop'
import NotUploaded from 'views/screens/Platform-administrator/Process/Create/Users/not-uploaded'
// routes
import { platformAdminRoutes } from 'router/routes'
import TestResultsBetesa from 'views/components/TestResultsBetesa'
import ResultsSkills from 'views/components/TestResultsSkills/results-skills'
import PreviewGenerateReport from 'views/components/preview-generate-report'
import WatchSettings from 'views/screens/Platform-administrator/Process/WatchSettings'
import TeamDevelopment from 'views/screens/Platform-administrator/TeamDevelopment'
import UsersManager from 'views/screens/Platform-administrator/TeamDevelopment/Components/UsersManager'
import TeamMapDevelopment from 'views/screens/Platform-administrator/TeamDevelopment/Components/TeamMapDevelopment'
import HistoryTeamMap from 'views/screens/Platform-administrator/TeamDevelopment/Components/HistoryTeamMap'
import DevelopmentPlan from 'views/screens/Evaluated-User/pages/DevelopmentPlan'
import EditIdealProfileBetesa from 'views/screens/Platform-administrator/Process/Edit/IdealProfileBetesa/ideal-profile-betesa'
import EditIdealProfileSkills from 'views/screens/Platform-administrator/Process/Edit/IdealProfileSkills'
import { ProtectedRoute } from 'router/components'
import TestResults360 from 'views/components/TestResults360'
import Questionary from 'views/screens/Questionary'
import TalentsQuestionnaire from 'views/screens/Modules/betesa-talents/pages/questionnaires'
import TalentsNewQuestionnaire from 'views/screens/Modules/betesa-talents/pages/questionnaires/New'
import TalentsQuestionnaireSettings from 'views/screens/Modules/betesa-talents/pages/questionnaires/Settings/SettingQuestionnaireBetesa'
import TalentsQuestionnaireSettingsInfo from 'views/screens/Modules/betesa-talents/pages/questionnaires/Settings/info/EditBasicInfoQuestionnaire'
import PlatformConfiguration from 'views/screens/Platform-administrator/Configuration'
import { specialAdminRoutes, superAdminRoutes } from 'router/routes'

const PlatformAdministratorRouter: FC = () => {
  const role = useSelector((state: any) => state.auth.role)
  const hasQuestionnaireManagement = useSelector((state: any) => state.user.hasQuestionnaireManagement)
  const canAccessQuestionnaires =
    role === 'super_platform_admin' ||
    ((role === 'platform_admin' || role === 'super_platform_admin') && hasQuestionnaireManagement === true)

  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path={platformAdminRoutes.Home} element={<Home />} />
      <Route path="*" element={<NotFound />} />
      <Route path={platformAdminRoutes.CreateProcess} element={<CreateProcess />} />
      <Route path={platformAdminRoutes.PreconfigProcess} element={<SelectPreconfig />} />
      <Route path={platformAdminRoutes.IdealProfileGeneratorAi} element={<IdealProfileGeneratorAi />} />
      <Route path={platformAdminRoutes.HomologationSkills} element={<HomologationSkills />} />
      <Route path={platformAdminRoutes.CreateEditHomologationSkills} element={<HomologationCreateEditSkills />} />
      <Route path={platformAdminRoutes.ProcessSkills} element={<ProcessSkills />} />
      <Route path={platformAdminRoutes.Process360} element={<Test360 />} />
      <Route path={platformAdminRoutes.SelectTestsType} element={<SelectTestsType />} />
      <Route path={platformAdminRoutes.IdealProfileBetesa} element={<IdealProfileBetesa />} />
      <Route path={platformAdminRoutes.EditIdealProfileBetesa} element={<EditIdealProfileBetesa />} />
      <Route path={platformAdminRoutes.EditIdealProfileSkills} element={<EditIdealProfileSkills />} />
      <Route path={platformAdminRoutes.CreateUsers} element={<CreateUsers />} />
      <Route path={platformAdminRoutes.NewUser} element={<CreateUsersNewProcess />} />
      <Route path={platformAdminRoutes.Resume} element={<ResumeUsersProcess />} />
      <Route path={platformAdminRoutes.UpdateEmail} element={<UpdateEmail />} />
      <Route path={platformAdminRoutes.NotUpload} element={<NotUploaded />} />
      <Route path={platformAdminRoutes.UnpublishedProcess} element={<UnpublishProcess />} />
      <Route path={platformAdminRoutes.ProcessesCreated} element={<DeliveredProcess />} />
      <Route path={platformAdminRoutes.MyProcess} element={<MyProcesses />} />
      <Route path={platformAdminRoutes.DetailProcessDelivered} element={<DeliveredProcesses />} />
      <Route path={platformAdminRoutes.UsersWithIncompleteTests} element={<UsersWithIncompletedTests />} />
      <Route path={platformAdminRoutes.EvaluatorsTest360} element={<EvaluatorsTest360 />} />
      <Route path={platformAdminRoutes.EvaluatedUsers} element={<EvaluatedSpace />} />
      <Route path={platformAdminRoutes.DetailEvaluatedUser} element={<EvaluatedDetail />} />
      <Route path={platformAdminRoutes.TestResultSkills} element={<ResultsSkills />} />
      <Route path={platformAdminRoutes.TestResultBetesa} element={<TestResultsBetesa />} />
      <Route
        path={platformAdminRoutes.Administrators}
        element={
          <ProtectedRoute requireAdminPlatformManagement={true}>
            <ProfileView />
          </ProtectedRoute>
        }
      />
      <Route path={platformAdminRoutes.TestResult360} element={<TestResults360 />} />
      <Route path={platformAdminRoutes.Skills} element={<PlatformSkills />} />
      <Route path={platformAdminRoutes.Analitycs} element={<Analytics />} />
      <Route path={platformAdminRoutes.AnalitycsMenu} element={<AnalyticsMigrationNotice />} />
      {role === 'super_platform_admin' && (
        <Route path={platformAdminRoutes.LuminaAnalytics} element={<LuminaAnalytics />} />
      )}
      <Route path={platformAdminRoutes.TalentsToDevelop} element={<TalentsToDevelop />} />
      <Route path={platformAdminRoutes.SelectTalentsToDevelop} element={<SelectTalentsToDevelop />} />
      <Route path={platformAdminRoutes.SelectSkillsToDevelop} element={<SelectSkillsToDevelop />} />
      <Route path={platformAdminRoutes.Inventory} element={<Inventory />} />
      <Route path="/reports-download" element={<PreviewGenerateReport />} />
      <Route path={platformAdminRoutes.watchSettings} element={<WatchSettings />} />
      <Route path={platformAdminRoutes.TeamDevelopment} element={<TeamDevelopment />} />
      <Route path={platformAdminRoutes.TeamDevelopmentUsers} element={<UsersManager />} />
      <Route path={platformAdminRoutes.TeamMapDevelopment} element={<TeamMapDevelopment />} />
      <Route path={platformAdminRoutes.TeamDevelopmentHistory} element={<HistoryTeamMap />} />
      <Route path={platformAdminRoutes.DevelopmentPlan} element={<DevelopmentPlan />} />
      {role === 'super_platform_admin' && (
        <Route path={platformAdminRoutes.Configuration} element={<PlatformConfiguration />} />
      )}
      {canAccessQuestionnaires && (
        <>
          <Route path={superAdminRoutes.Cuestionario} element={<Questionary />} />
          <Route path={specialAdminRoutes.QuestionnairesBetesa} element={<TalentsQuestionnaire />} />
          <Route path={specialAdminRoutes.NewQuestionnaireBetesa} element={<TalentsNewQuestionnaire />} />
          <Route path={superAdminRoutes.SettingQuestionaire} element={<TalentsQuestionnaireSettings />} />
          <Route path={superAdminRoutes.EditBasicInfoQuestionaire} element={<TalentsQuestionnaireSettingsInfo />} />
        </>
      )}
    </Routes>
  )
}

export default PlatformAdministratorRouter
